import React from "react";
import {Box} from "@mui/material";

const UserLayout = ({children, pb, minH}) => {
    return (
        <Box sx={{
            // Callers whose content should size to itself (e.g. a table that
            // ends in pagination) can shorten the card via `minH`.
            minHeight: minH ?? 'calc(100vh - 150px)',
            background: "#FFFFFF",
            padding: { lg: '32px', md: '28px', sm: '22px', xs: '14px' },
            // Clear the fixed bottom nav (shown below lg) so content isn't hidden behind it.
            // Callers without a bottom nav (e.g. detail side panels) can override via `pb`.
            pb: pb ?? { xs: '96px', sm: '100px', md: '100px', lg: '32px' },
            borderRadius: '12px',
            border: '1px solid #F0E6DF',
            boxShadow: '0 4px 24px rgba(192,53,122,0.06)',
            overflow: 'hidden',
        }}>
            {children}
        </Box>
    );
};

export default UserLayout;
